<template>
  <section class="share">
    <div class="title">
      <span>&nbsp;&nbsp;A Call</span>
      <br />
      <span>to Arms for</span>
      <br />
      <span>&nbsp;&nbsp;&nbsp;Change.</span>
    </div>
    <div class="wrapper">
      <div class="container">
        <div class="text">
          Stand under the banner<br />“Violence is not my culture” and share this message to shed a brighter light on an aberrant action that shouldn’t be hidden under a rug.
        </div>
        <div class="share-buttons">
          <a href="/static/download/violenceisnotmyculture_IG.zip">
            <div class="share-button">
              <span>IG</span>
            </div>
          </a>
          <a href="/static/download/violenceisnotmyculture_TW.zip">
            <div class="share-button">
              <span>TW</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import aion from '@/scripts/aion';
import animations from '@/assets/animations';
import { SplitText } from '@/assets/libs/SplitText';

export default {
  name: 'ShareSection',

  data() {
    return {
      split: null,
      entered: false,
    };
  },

  mounted() {
    this.split = new SplitText(this.$el.querySelector('.text'));
    aion.add(() => {
      if (this.$el.querySelector('.wrapper').getBoundingClientRect().top < window.innerHeight && !this.entered) {
        this.entered = true;
        animations.get('text-enter')(this.split).play();
      }
    }, 'share-enter');
  },
};
</script>

<style lang="scss" scoped>
.share {
  .title {
    padding-left: 100px;
    font-size: rem(360px);
    font-size: calc(360px * var(--rw));
    line-height: rem(300px);
    line-height: calc(300px * var(--rw));
    visibility: hidden;

    @include mq($until: ipadL) {
      font-size: rem(180px);
      line-height: rem(150px);
    }

    @include mq($until: ipadP) {
      font-size: rem(100px);
      line-height: rem(80px);
      padding-left: 20px;
    }
  }

  .wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;

    @include mq($from: dl) {
      margin-top: calc(200px * var(--rw));
    }

    @include mq($until: ipadP) {
      margin-top: 80px;
    }
  }

  .container {
    margin-right: 200px;

    @include mq($until: ipadL) {
      margin-right: 100px;
    }

    @include mq($until: ipadP) {
      margin-left: auto;
      margin-right: auto;
      width: 90%;
    }
  }

  .text {
    width: 500px;
    font-family: 'GT America Mono';
    font-size: rem(20px);
    line-height: rem(34px);

    @include mq($until: ipadP) {
      font-size: rem(18px);
      width: 70%;
      margin-left: auto;
      margin-right: auto;
      padding: 0px 25px;
    }
  }

  .share-buttons {
    margin-top: 200px;

    @include mq($until: ipadL) {
      margin-top: 80px;
    }
  }

  .share-button {
    display: inline-block;
    border-radius: 100%;
    padding: 10px 0px;
    width: 240px;
    border: 2px solid $color-light;
    text-align: center;
    transition: all .6s cubic-bezier(.9, .25, .1, .75);

    @include mq($until: ipadL) {
      width: 130px;
    }

    &:nth-child(1) {
      margin-right: 100px;

      @include mq($until: ipadP) {
        margin-right: 20px;
      }
    }

    &:hover {
      background-color: $color-primary;
      border-color: $color-primary;

      span {
        -webkit-text-stroke-color: $color-white;
      }
    }

    span {
      font-size: rem(60px);
      font-family: 'GT America Expanded';
      -webkit-text-fill-color: transparent;
      -webkit-text-stroke-width: 2px;
      -webkit-text-stroke-color: $color-primary;
      transition: -webkit-text-stroke-color .6s cubic-bezier(.9, .25, .1, .75);

      @include mq($until: ipadL) {
        font-size: rem(40px);
      }
    }
  }
}
</style>
